import { AppBar, Container, Toolbar, Button } from '@mui/material'
import { VpnKey as VpnKeyIcon, History as HistoryIcon, FactCheck as FactCheckIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const KeyVaultNav = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <AppBar position="sticky" elevation={0} sx={(theme) => ({ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary, top: 0, mb: 0, borderBottom: `1px solid ${theme.palette.divider}` })}>
      <Container maxWidth="xl" disableGutters>
        <Toolbar disableGutters variant="dense">
          <Button
            color="inherit"
            startIcon={<VpnKeyIcon />}
            onClick={() => navigate('/key-vault/new-secrets')}
            sx={{ ml: 2 }}
          >
            {t('keyVault.newSecrets')}
          </Button>
          <Button
            color="inherit"
            startIcon={<FactCheckIcon />}
            onClick={() => navigate('/key-vault/validate-secrets')}
            sx={{ ml: 2 }}
          >
            {t('keyVault.validateSecrets.title')}
          </Button>
          <Button
            color="inherit"
            startIcon={<HistoryIcon />}
            onClick={() => navigate('/key-vault/audit')}
            sx={{ ml: 2 }}
          >
            {t('keyVault.audit.title')}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default KeyVaultNav
